export const formatAddress = (
  address: string,
  physicianCity: string,
  physicianState: string,
  physicianZip: string
) => {
  const parts = address.split(',')

  return {
    line1: parts[0],
    line2: `${physicianCity}, ${physicianState}, ${physicianZip}`,
  }
}
